import { GTAG_ENABLED, GTAG_ID, HOST_NAME } from '@/config';

export default {
  config: {
    id: GTAG_ID,
    params: {
      send_page_view: true,
    },
  },
  enabled: GTAG_ENABLED,
  appName: HOST_NAME,
};
